import type { ComponentOptionsMixin } from "vue";

const mix: ComponentOptionsMixin = {
  data: () => ({
    componentId: "a" + Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7)
  })
};

export default mix;
